export default "__VITE_ASSET__BmKUE5mk__"